
  var _styles = {
  "cfe-city-list": {
    "display": "flex",
    "flexDirection": "column"
  },
  "cfe-city-list-letter": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.48rem",
    "fontWeight": "500",
    "color": "rgb(32,32,32)",
    "fontFamily": "PingFang SC",
    "marginTop": "0.45333rem",
    "marginBottom": "0.18667rem",
    "marginLeft": "0.53333rem"
  },
  "cfe-city-list-divider": {
    "height": "0.01333rem",
    "backgroundColor": "rgb(244,245,248)",
    "marginLeft": "0.53333rem",
    "marginRight": "0.53333rem"
  },
  "cfe-city-list-item": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "cfe-city-list-name": {
    "fontSize": "0.37333rem",
    "lineHeight": "0.53333rem",
    "color": "rgb(34,34,34)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "marginTop": "0.32rem",
    "marginBottom": "0.32rem",
    "marginLeft": "0.53333rem"
  },
  "cfe-city-list-bottom-space": {
    "height": "1.06667rem"
  }
};



  module.exports = _styles;
  